import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'header-mobile',
    templateUrl: './header-mobile.component.html',
    styleUrls: ['./header-mobile.component.scss'],
    standalone: false
})
export class HeaderMobileComponent {
  @Input('p-titulo') titulo: string;
  @Input('p-icone') icone: string;
}